import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LoginPage from './Components/Login/Login';
import NotFound from './Components/404/Error';
import Home from './Components/Home/home';
import Location from './Components/Location/Locations';
import UserReport from './Components/Reports/UserReport';
import { UserContext } from "./Utilis";
import FishStatusCCO from './Components/FishData/FishStatusCCO';
import FishStatusBelvedere from './Components/FishData/FishStatusBelvedere';
import FishStatusSolin from './Components/FishData/FishStatusSolin';
import FishStatusMall from './Components/FishData/FishStatusMall';
import FishStatusKaufland from './Components/FishData/FishStatusKaufland';
import FishStatusBrela from './Components/FishData/FishStatusBrela';
import FishStatusPodstrana from './Components/FishData/FishStatusPodstrana';
import FishStatusOmis from './Components/FishData/FishStatusOmis';
import FishStatusBrda from './Components/FishData/FishStatusBrda';
import FishStatusPoljud from './Components/FishData/FishStatusPoljud';
import FishStatusGomilica from './Components/FishData/FishStatusGomilica';
import Analitika from './Components/Analitika/Analitika';
import NalogUser from './Components/Nalog/NalogUser';
import WeeklyReport from './Components/Analitika/TjedniOtpis';
import GapAnaliza from './Components/GapAnaliza/GapAnaliza';
import AdminDashboard from './Components/Nalog/AdminDashboard';
import AnalyticsListener from './Components/AnalyticsListener';
import FishStatusSvKajo from './Components/FishData/FishStatusSvKajo';
import CheckToken from './CheckToken';
import FondInventoryTotal from './Components/Reports/Total';

const locationComponents = {
  cco: FishStatusCCO,
  belvedere: FishStatusBelvedere,
  solin: FishStatusSolin,
  mall: FishStatusMall,
  kaufland: FishStatusKaufland,
  brela: FishStatusBrela,
  podstrana: FishStatusPodstrana,
  omis: FishStatusOmis,
  brda: FishStatusBrda,
  poljud: FishStatusPoljud,
  svkajo: FishStatusSvKajo,
  gomilica: FishStatusGomilica,
};

const DynamicFishStatus = () => {
  const { locationName } = useParams();
  const Component = locationComponents[locationName];
  return Component ? <Component /> : <NotFound />;
};

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const { isValid, decoded } = CheckToken(false);
    if (isValid && !user) {
      setUser({ email: decoded.email, userId: decoded.userId });
    } else {
      localStorage.removeItem("token");
    }
  }, []);
  useEffect(() => {
    if (!user) return;

    const interval = setInterval(() => {
      const { isValid } = CheckToken();
      if (!isValid) {
        clearInterval(interval);
        setUser(null);
        localStorage.removeItem("token");
      }
    }, 600000);

    return () => clearInterval(interval);
  }, [user]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      <BrowserRouter>
        <AnalyticsListener />
        <Routes>
          <Route path='/' element={<LoginPage />} />
          <Route path='/*' element={<NotFound />} />
          <Route path="/home" element={<Home />}>
            <Route path="Inventura" element={<UserReport />} />
            <Route path="Analitika" element={<Analitika />} />
            <Route path="gap-analiza" element={<GapAnaliza />} />
            <Route path="Tjedni-otpis" element={<WeeklyReport />} />
            <Route path="Nalozi" element={<NalogUser />} />
            <Route path="Podjela" element={<FondInventoryTotal />} />
            {/* <Route path="Before" element={<FondInventoryBefore />} />
            <Route path="After" element={<FondInventoryAfter />} /> */}
            <Route
              index
              element={
                user?.email === 'dragan@ribarnice.hr' ||
                  user?.email === 'riba@centaurus.hr' ||
                  user?.email === 'prodaja2@centaurus.hr' ||
                  user?.email === 'projekti@centaurus.hr' ||
                  user?.email === 'skladiste@ribarnice.hr'
                  ? <UserReport />
                  : user?.email === 'dubravko@bluedatab.com'
                    ? <AdminDashboard />
                    : <Location />
              }
            />
            <Route path="status/:locationName" element={<DynamicFishStatus />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </UserContext.Provider>
  );
}

export default App;
